// Wraps occurrences of entity names inside an HTML string with clickable highlight spans.
export function highlightHtml(html, entities) {
  if (!html || !entities || entities.length === 0) return html || "";
  const doc = new DOMParser().parseFromString(html, "text/html");

  // Build a list of matchable terms (name + nickname) each pointing to its entity.
  const terms = [];
  entities.forEach((e) => {
    if (e.name) terms.push({ text: e.name, entity: e });
    if (e.nickname) terms.push({ text: e.nickname, entity: e });
  });
  // Sort by term length desc so longer names match first.
  const sorted = terms.sort((a, b) => b.text.length - a.text.length);
  const escaped = sorted.map((t) => t.text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"));
  if (escaped.length === 0) return html;
  const regex = new RegExp(`\\b(${escaped.join("|")})\\b`, "gi");
  const byText = {};
  sorted.forEach((t) => (byText[t.text.toLowerCase()] = t.entity));

  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  const nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);

  nodes.forEach((node) => {
    const text = node.nodeValue;
    if (!regex.test(text)) return;
    regex.lastIndex = 0;
    const frag = doc.createDocumentFragment();
    let last = 0;
    let m;
    while ((m = regex.exec(text)) !== null) {
      const matched = m[0];
      const ent = byText[matched.toLowerCase()];
      if (m.index > last) frag.appendChild(doc.createTextNode(text.slice(last, m.index)));
      if (ent) {
        const span = doc.createElement("span");
        span.className = `entity-hl entity-${ent.type}`;
        span.setAttribute("data-entity-id", ent.id);
        span.setAttribute("data-testid", `entity-highlight-${ent.id}`);
        span.textContent = matched;
        frag.appendChild(span);
      } else {
        frag.appendChild(doc.createTextNode(matched));
      }
      last = m.index + matched.length;
    }
    if (last < text.length) frag.appendChild(doc.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  });

  return doc.body.innerHTML;
}
